/* @flow */

export const RELATIVE_TIMESTAMP_FORMATS = {
    FROM_NOW: 'fromNow',
    TO_NOW: 'toNow',
    CALENDAR: 'calendar',
    HOUR_HYBRID: 'hourHybrid',
};

export type RelativeTimestampFormat = $Values<typeof RELATIVE_TIMESTAMP_FORMATS>;
